import { fetchBundle, updateMembershipFromNonPaymentBundle, createBundlePaymentOrder, updateMembershipAfterPaymentForBundle } from '../../clients/bundle'
import { fromStrapiBundle } from '../../helpers/mapping/bundle'
import { Bundle } from '../../types/Bundle'
import LocalStorageKeys from '../../types/LocalStorageKeys'

class BundleRepository {
    async getBundle(bundleCode: string): Promise<Bundle> {
        const data = await fetchBundle(bundleCode)
        return fromStrapiBundle(data)
    }

    async updateMembershipFromNonPaymentBundle(bundleCode: string) {
        return updateMembershipFromNonPaymentBundle(bundleCode)
    }

    async createBundlePaymentOrder(bundleCode: string) {
        const clientSecret: {clientSecret: string, paymentIntentId: string} = await createBundlePaymentOrder(bundleCode)
        return clientSecret
    }

    async updateMembershipAfterPaymentForBundle(bundleCode: string, stripePaymentIntentId: string) {
        return updateMembershipAfterPaymentForBundle(bundleCode, stripePaymentIntentId)
    }

    setBundleCode(bundleCode?: string) {
        if (bundleCode) {
            localStorage.setItem(LocalStorageKeys.BUNDLE, bundleCode)
        } else {
            localStorage.removeItem(LocalStorageKeys.BUNDLE)
        }
    }

    getBundleCode() {
        return localStorage.getItem(LocalStorageKeys.BUNDLE)
    }
}

export default BundleRepository